export default "__VITE_ASSET__CmjD2Bko__"